import React, { createContext, useContext, ReactNode } from "react";
import { useSocialMentionSearch, SocialMentionSearchHook } from "./hooks/useSocialMentionSearch";
import { AbstractPlayer } from "./index";
import { SocialMentionData } from "@/services/bedrock/dtos/Post";
import { SocialNetworksId } from "@/interfaces";

interface SearchContextType extends SocialMentionSearchHook {
  players: AbstractPlayer[];
  networksFilter?: SocialNetworksId[];
  isPosted?: boolean;
}

const SearchContext = createContext<SearchContextType | undefined>(undefined);

export function useSearchContext() {
  const context = useContext(SearchContext);
  if (!context) {
    throw new Error("useSearchContext must be used within a SearchProvider");
  }
  return context;
}

interface SearchProviderProps {
  children: ReactNode;
  players: AbstractPlayer[];
  mentions: SocialMentionData[];
  onAddMention: (mention: SocialMentionData) => void;
  onRemoveMention: (mention: SocialMentionData) => void;
  networksFilter?: SocialNetworksId[];
  isPosted?: boolean;
}

export function SearchProvider({
  children,
  players,
  mentions,
  onAddMention,
  onRemoveMention,
  networksFilter,
  isPosted,
}: SearchProviderProps) {
  const search = useSocialMentionSearch({ players, mentions, onAddMention, onRemoveMention });

  const value = {
    ...search,
    players,
    networksFilter,
    isPosted,
  };

  return <SearchContext.Provider value={value}>{children}</SearchContext.Provider>;
}
